export type SortType = {
  orderBy: string;
  orderType: OrderEnum;
};

export enum OrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SearchType = {
  search: string;
  searchBy: string;
};

export type FilterTableType = SortType & SearchType;

/**
 * Valid column cell renderer types
 */
export type ColumnType =
  | 'default'
  | 'date'
  | 'datetime'
  | 'collaborators'
  | 'custom'
  | 'priority'
  | 'status'
  | 'boolean-icon'
  | 'boolean-text'
  | 'multiline'
  | 'examType';

/**
 * Type-safe icon configuration
 * Replaces unsafe HTML string rendering
 */
export interface IconConfig {
  /** Icon CSS class (e.g., 'icon-tag', 'icon-check') */
  iconClass: string;
  /** Optional title/tooltip for the icon */
  title?: string;
  /** Optional additional CSS classes for styling */
  additionalClasses?: string;
}

/**
 * Configuration for custom column rendering
 * Allows declarative configuration of table columns behavior
 */
export interface ColumnConfig {
  key: string;
  label: string;
  searchable?: boolean;
  icon?: string;
  /** Type of cell renderer */
  type?: ColumnType;
  /** Pipe to apply for formatting (e.g., 'formattedDate', 'fullDateTime') */
  pipe?: 'formattedDate' | 'fullDateTime';
  timezone?: string;
  /** Icon class to render for boolean-icon column type */
  booleanIcon?: string;
  booleanTrueText?: string;
  booleanFalseText?: string;
  /** Type-safe icon configuration to render before cell value (replaces prefixHtml) */
  prefixIcon?: string;
  /** Type-safe icon configuration to render after cell value (replaces suffixHtml) */
  suffixIcon?: string;
  /** HTML prefix to render before cell value (e.g., icons) - rendered with innerHTML */
  prefixHtml?: string;
  /** HTML suffix to render after cell value (e.g., icons) - rendered with innerHTML */
  suffixHtml?: string;
  /** Cell text alignment - useful for numeric columns like in Excel */
  align?: 'left' | 'center' | 'right';
  /** Custom tooltip configuration */
  tooltip?: {
    field?: string;
    prefix?: string;
    alwaysShow?: boolean;
    pipe?: 'formattedDate' | 'fullDateTime';
    timezone?: string;
  };
  [key: string]: unknown;
}
